export default __webpack_public_path__ + "static/media/icon-report-student.328679ba.svg";